module.exports = __webpack_public_path__ + "img/lens-167-plus-08.0ac55c4e.png";